// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon--small[data-v-211d1fa8]{width:12px;height:12px}.icon--normal[data-v-211d1fa8]{width:14px;height:14px}.icon--large[data-v-211d1fa8]{width:16px;height:16px}.icon--x-large[data-v-211d1fa8]{width:20px;height:20px}.icon--biggest[data-v-211d1fa8]{width:30px;height:30px}", ""]);
// Exports
module.exports = exports;
